import {
  REQUEST_SEARCH_RESULTS,
  REQUEST_SEARCH_RESULTS_LOCAL,
  RECEIVE_SEARCH_RESULTS,
  ERROR_SEARCH_RESULTS
} from 'typeConstants';
import {search as initialState} from '../initialState.tsx';

const search = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SEARCH_RESULTS_LOCAL:
    case REQUEST_SEARCH_RESULTS:
      return {
        ...state,
        lastSearchTime: Date.now(),
        searchText: action.payload,
        isFetching: action.type === REQUEST_SEARCH_RESULTS
      };
    case RECEIVE_SEARCH_RESULTS:
      return {
        ...state,
        items: action.payload,
        isFetching: false
      };
    case ERROR_SEARCH_RESULTS:
      return {
        ...state,
        isFetching: false
      };
    default:
      return state;
  }
};

export default search;
